import { render, staticRenderFns } from "./MonthlyValues.vue?vue&type=template&id=0b66d5be&scoped=true"
import script from "./MonthlyValues.vue?vue&type=script&lang=js"
export * from "./MonthlyValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66d5be",
  null
  
)

export default component.exports